var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"category-member-type-tab"}},[_c('div',{staticClass:"at-member-tab-left-container"},_vm._l((_vm.leftCategory),function(cat,idx){return _c('div',{key:idx,class:[
        _vm.leftActiveTab === cat.value ? 'active' : '',
        _vm.loading ? 'loading' : '',
        'at-member-tab',
      ],on:{"click":function($event){return _vm.leftToggle(cat.value)}}},[(!cat.hide)?_c('span',{staticClass:"at-member-label"},[_vm._v(_vm._s(cat.label))]):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }